export const QuoteStatusesLabels = {
  ACTIVE: 'Vigentes',
  QUOTED: 'Presupuestado',
  ACCEPTED: 'Aceptado',
  SCHEDULED: 'Programado',
  INVOICED: 'Facturado',
  CANCELLED: 'Cancelado',
}

export const QuoteStatuses = {
  QUOTED: 'QUOTED',
  SCHEDULED: 'SCHEDULED',
  ACCEPTED: 'ACCEPTED',
  INVOICED: 'INVOICED',
  CANCELLED: 'CANCELLED',
}